import { HeadersFunction, LoaderFunction, MetaFunction } from "react-router";
import SatsangAppInfo from "~/components/AppsInfo/SatsangAppInfo";
import { getPageMeta } from "~/lib/helperFuncation/metaHelper";
import { CACHED_PAGE, FALLBACK_IMAGE_URL, LANG } from "~/utils/constant";
import { computeEtagFromData } from "~/utils/helper-funcations";
import { metaService } from "~/utils/metaService";

export const loader: LoaderFunction = ({ params, request }) => {
  const lang = params.lang || LANG.english;
  const DATA = {
    title: lang == LANG.english ? "Satsang App" : "સત્સંગ એપ",
  };

  const etag = computeEtagFromData(DATA);
  const ifNoneMatch = request.headers.get("If-None-Match");
  if (ifNoneMatch === etag) {
    return new Response(null, {
      status: 304,
      headers: {
        Etag: etag,
      },
    });
  }

  return Response.json(DATA, {
    headers: { ...CACHED_PAGE.APPS.HEADERS, ETag: etag },
  });
};

export const headers: HeadersFunction = ({ loaderHeaders }) => loaderHeaders;

export const meta: MetaFunction = ({ location, params }) => {
  const { pathname, search } = location;
  const lang = params.lang || "en";
  const meta = getPageMeta("apps", lang);
  const title = "Satsang App";
  return metaService({
    title: title ?? meta.metaTitle,
    description: meta.metaDescription,
    ogTitle: title ?? meta.ogTitle,
    ogDescription: meta.ogDescription,
    ogImg: meta.ogImage || FALLBACK_IMAGE_URL,
    ogWidth: meta.ogImageWidth || "1200",
    ogHeight: meta.ogImageHeight || "630",
    ogUrl: pathname,
    canonicalLink: pathname + search,
    hreflangs: [
      { hrefLang: "x-default", href: `${pathname}` },
      { hrefLang: "en", href: `${pathname}` },
      { hrefLang: "gu", href: `${pathname}` },
    ],
  });
};

const SatsangApp = () => {
  return (
    <div className="w-full flex justify-center items-center">
      <SatsangAppInfo />
    </div>
  );
};

export default SatsangApp;
